/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable arrow-body-style */
import { useEffect, useState } from 'react';
import { CircularProgessBm, SelectBm } from 'src/components/@material-extend';
import { useAllProducers } from 'src/components/api/queries/hooks';

export const SelectRancher = ({ value, setValue, defaultValue, partnerId }) => {
  const [list, setList] = useState([]);
  const { data, isLoading } = useAllProducers({
    status: 'CONFIRMED',
    partnerId
  });

  const getListOfRancher = async () => {
    try {
      const newList = data?.map(({ email, producerId, familyName, givenName }) => {
        return {
          label: `${givenName} ${familyName}-${email}`,
          value: producerId
        };
      });
      setList(newList);
      setValue(defaultValue || newList[0].value);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!partnerId) {
      setValue('');
      return;
    }
    const len = partnerId.length;
    if (len < 4 || len === 5) {
      setValue('');
      return;
    }

    getListOfRancher();
  }, [partnerId,data]);

  if (isLoading) {
    return <CircularProgessBm />;
  }

  return (
    <SelectBm
      containerSx={{
        width: '100%'
      }}
      sx={{
        bgcolor: '#F1F1F1',
        borderRadius: 1
      }}
      list={list}
      label="Rancher*"
      disabled={defaultValue ? true : false}
      value={value}
      onChange={({ target }) => setValue(target.value)}
    />
  );
};
